//
//
//
//
//
//
//
//
//

export default {
  name: "BluePaginationItem",
  props: ["index", "number", "goToPage", "isActive", "isNumber", "isEllipsis"],
  computed: {
    type() {
      return this.isActive ? "span" : "button";
    }
  },
};
